var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('earth-layout',[_c('template',{slot:"A"},[_c('h1',{staticClass:"title has-margin-bottom-0"},[_vm._v("\n      "+_vm._s(_vm.$t("_.sales_listing"))+"\n    ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('router-view')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }